export default (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }

  return /^(?=.*[a-z])(?=.*\d).{8,}$/.test(value);
};



// WEBPACK FOOTER //
// ./src/utils/validators/Password.js